var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:home-24-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.45 2.53301C13.0442 2.19104 12.5307 2.00348 12 2.00348C11.4693 2.00348 10.9558 2.19104 10.55 2.53301L3.8 8.22801C3.54946 8.43917 3.34806 8.70249 3.20988 8.99959C3.0717 9.29668 3.00007 9.62036 3 9.94801V19.253C3 20.219 3.784 21.003 4.75 21.003H7.75C8.21413 21.003 8.65925 20.8186 8.98744 20.4904C9.31563 20.1623 9.5 19.7171 9.5 19.253V15.25C9.5 14.57 10.042 14.018 10.717 14H13.283C13.6088 14.0086 13.9183 14.1441 14.1456 14.3776C14.373 14.6111 14.5001 14.9241 14.5 15.25V19.253C14.5 20.219 15.284 21.003 16.25 21.003H19.25C19.7141 21.003 20.1592 20.8186 20.4874 20.4904C20.8156 20.1623 21 19.7171 21 19.253V9.94701C20.9999 9.61936 20.9283 9.29568 20.7901 8.99858C20.6519 8.70149 20.4505 8.43817 20.2 8.22701L13.45 2.53301Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f144413ee133234c89c565adaa5d20ee.svg";
export { ForwardRef as ReactComponent };